import { HttpError } from 'src/http/errors/http-error';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { Either } from 'src/utils/either';

import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from '../../http';

export class RestaurantsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getRestaurants(
    params?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `gastronomy/all-restaurants-admin`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createRestaurant(
    body?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `gastronomy`,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateRestaurant(
    id: string,
    body?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `gastronomy/${id}`,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async changeStatus(
    id: string
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `gastronomy/change-status/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async deleteRestaurant(
    id: string
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: `gastronomy/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadImage(body?: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `media/upload/base64/restaurants`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
